<template>
  <div class="background">
    <div class="card">
      <img
        src="../assets/back.png"
        alt="Return"
        class="return-icon"
        @click="$router.go(-1)"
      />
      <div class="title">Create your account 3/3</div>
      <img src="../assets/congrats.png" alt="" class="congrat-pic" />
      <div class="reminders">
        <div class="content">
          <div class="sub-title1">Congratulations!</div>
          <div class="sub-title1">Your account has been created!</div>
          <div class="sub-title">Start using your account number</div>
          <div class="copy">
            <div class="inside">
              {{ address }}
            </div>
          </div>
        </div>
      </div>
      <button v-if="buttonStatus == 0" class="button" @click="claim()">
        <span>Claim 0.01 CNHO Token</span>
      </button>
      <button v-if="buttonStatus == 1" class="button grey">
        <span>Claiming...</span>
      </button>
      <button
        v-if="buttonStatus == 2"
        class="button"
        @click="jump_account_page()"
      >
        <span>Claimed! Check your balance</span>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedPic: require("../assets/selected.png"),
      unSelectedPic: require("../assets/not-select.png"),
      address: null,
      isSave: false,
      buttonStatus: 0,
    };
  },
  mounted() {
    this.address = this.$route.query.address;
    console.log("addresssss", this.address, this.address.length == 0);
    if (this.address.length == 0) {
      this.$router.push({ name: "create-1" });
    }
  },
  methods: {
    jump() {
      if (this.isSave) {
        this.$router.push({ name: "create-3" });
      }
    },
    jump_account_page() {
      window.location.href = "https://explorer.cnho.io/account/" + this.address;
    },
    claim() {
      this.buttonStatus = 1;
      fetch("https://159.138.232.248/chain/faucet", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          address: this.address,
          coins: ["10ucnho"],
        }),
      })
        .then((response) => {
          if (!response.ok) {
            this.buttonStatus = 0;
            throw new Error("Network response was not ok");
          }
          this.buttonStatus = 2;
          return response.json();
        })
        .catch((error) => {
          this.buttonStatus = 0;
          console.error(
            "There has been a problem with your fetch operation:",
            error
          );
        });
    },
  },
};
</script>
<style scoped>
html {
  /* width: 1920px;
    height: 937px; */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  background: #006e54;
  border-radius: 0px 0px 0px 0px;
}

.card {
  position: relative;
  margin: calc(100 / 937 * 100vh) auto 0;
  width: calc(556 / 1920 * 100vw);
  height: calc(774 / 937 * 100vh);
  background: #ffffff;
  border-radius: calc(28 / 1920 * 100vw);
}
@media (max-width: 600px) {
  .card {
    width: 90vw; /* 在小屏幕上，让卡片宽度更适应屏幕 */
    margin-top: 10vh; /* 调整边距 */
    border-radius: 10px; /* 调整边角半径 */
  }
  .return-icon {
    left: calc(10 / 90 * 100vw) !important;
    width: calc(5 / 90 * 100vw) !important;
    height: calc(5 / 90 * 100vw) !important;
  }

  .reminders {
    position: absolute;
    left: calc(10 / 90 * 100vw) !important;
    top: calc(380 / 932 * 100vh) !important;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: calc(17 / 90 * 100vw);
    color: #000000;
    line-height: calc(22 / 90 * 100vw);
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .title {
    position: absolute;
    left: calc(10 / 90 * 100vw) !important;
    font-size: 21px !important;
  }
  .content {
    line-height: 22px !important;
  }

  .content .sub-title {
    height: calc(100 / 932 * 100vh) !important;
    font-size: calc(15 / 932 * 100vh);
    line-height: calc(18 / 932 * 100vh);
    margin-bottom: calc(4 / 932 * 100vh);
  }
  .content .sub-title1 {
    font-size: 18px !important;
    font-family: Roboto-Bold;
    width: calc(60 / 90 * 100vw) !important;
    word-wrap: break-word !important;
    line-height: calc(6 / 90 * 100vw) !important;
  }
  .content .copy {
    display: flex;
    width: calc(65 / 90 * 100vw) !important;
    background: #f4fbf8;
    border-radius: 6px 6px 6px 6px;
  }
  .congrat-pic {
    position: absolute;
    top: calc(220 / 932 * 100vh) !important;
    left: calc(30 / 90 * 100vw) !important;
    width: calc(20 / 90 * 100vw) !important;
    height: calc(20 / 90 * 100vw) !important;
  }
  .content .copy .inside {
    width: calc(60 / 90 * 100vw) !important;
    font-size: 18px !important;
    padding: calc(10 / 932 * 100vh) calc(2 / 90 * 100vw) !important;
  }
  .button {
    position: absolute;
    bottom: calc(116 / 932 * 100vh) !important;
    left: calc(10 / 90 * 100vw) !important;
    width: calc(60 / 90 * 100vw) !important;
    height: calc(9 / 90 * 100vw) !important;
    background: #028760;
    border-radius: 6px 6px 6px 6px;
    border: none;
  }
  .grey {
    opacity: 0.2;
  }
  .space1 {
    height: 1px;
    width: calc(10 / 1920 * 100vw);
  }
  .button span {
    width: calc(50 / 90 * 100vw) !important;
    height: calc(10 / 90 * 100vw) !important;
    font-size: 18px !important;
    line-height: 18px !important;
  }
}
.return-icon {
  position: absolute;
  margin: 0;
  padding: 0;
  width: calc(28 / 1920 * 100vw);
  height: calc(28 / 1920 * 100vw);
  top: calc(80 / 937 * 100vh);
  left: calc(80 / 1920 * 100vw);
  background: #ffffff;
}

.reminders {
  position: absolute;
  top: calc(396 / 937 * 100vh);
  left: calc(80 / 1920 * 100vw);
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: calc(17 / 1920 * 100vw);
  color: #000000;
  line-height: calc(22 / 1920 * 100vw);
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.content {
  display: flex;
  height: calc(82 / 937 * 100vh);
  flex-direction: column;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: calc(17 / 1920 * 100vw);
  color: #000000;
  line-height: calc(22 / 1920 * 100vw);
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: calc(36 / 937 * 100vh);
}
.congrat-pic {
  position: absolute;
  top: calc(252 / 937 * 100vh);
  left: calc(230 / 1920 * 100vw);
  width: calc(96 / 937 * 100vh);
  height: calc(96 / 937 * 100vh);
}
.content .sub-title1 {
  font-size: calc(28 / 1920 * 100vw);
  font-family: Roboto-Bold;
  width: calc(774 / 1920 * 100vw);
  word-wrap: break-word !important;
  line-height: calc(30 / 1920 * 100vw);
}
.content .sub-title {
  display: block;
  height: calc(18 / 937 * 100vh);
  font-family: Roboto-Medium;
  font-weight: 500;
  font-size: calc(15 / 937 * 100vh);
  color: #000000;
  line-height: calc(18 / 937 * 100vh);
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: calc(24 / 937 * 100vh);
}
.content .copy {
  display: flex;
  width: calc(396 / 1920 * 100vw);
  /* height: calc(80 / 937 * 100vh); */
  background: #f4fbf8;
  border-radius: 6px 6px 6px 6px;
  margin-top: calc(4 / 937 * 100vh);
}
.content .copy .inside {
  width: calc(382 / 1920 * 100vw);
  font-size: calc(17 / 937 * 100vh);
  font-family: Roboto-Regular;
  color: #000000;
  word-wrap: break-word;
  margin: calc(10 / 937 * 100vh) calc(12 / 1920 * 100vw);
}
.button {
  position: absolute;
  bottom: calc(116 / 937 * 100vh);
  left: calc(80 / 1920 * 100vw);
  width: calc(396 / 1920 * 100vw);
  height: calc(40 / 1920 * 100vw);
  background: #028760;
  border-radius: 6px 6px 6px 6px;
  border: none;
}
.grey {
  opacity: 0.2;
}
.space1 {
  height: 1px;
  width: calc(10 / 1920 * 100vw);
}
.button span {
  width: calc(50 / 1920 * 100vw);
  height: calc(20 / 1920 * 100vw);
  font-family: Roboto, Roboto;
  font-weight: 500;
  font-size: calc(17 / 1920 * 100vw);
  color: #ffffff;
  line-height: 0px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
</style>
